import React, { useState } from 'react';
import { Container, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { notyf } from '../../utils/Notyf';
import '../../style/Blog.css';

const Register = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      notyf.error('Passwords do not match.');
      return;
    }

    const response = await fetch('https://blog-app-2-v2of.onrender.com/users/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, username, password }),
    });

    const data = await response.json();

    if (response.ok) {
      notyf.success('Account successfully created!');
      navigate('/login');
    } else {
      switch (data.error) {
        case 'Email already registered':
          notyf.error('This email address is already in use.');
          break;
        case 'Username already taken':
          notyf.error('Username is already in use.');
          break;
        case 'Email invalid':
          notyf.error('Please enter a valid email address.');
          break;
        case 'Password must be at least 8 characters':
          notyf.error('Password must be at least 8 characters.');
          break;
        case 'Username is required':
          notyf.error('Please choose a username.');
          break;
        default:
          notyf.error(data.error || 'Registration failed. Please try again.');
      }
    }
  };

  return (
    <Container className="mt-5 d-flex justify-content-center">
      <div className="retro-window" style={{ width: '100%', maxWidth: '400px' }}>
        <div className="window-dots mb-3">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h2 className="text-center mb-4">Register</h2>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
              size="sm"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              placeholder="Choose a username"
              size="sm"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              size="sm"
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              required
              placeholder="Re-enter your password"
              size="sm"
            />
          </Form.Group>
          <button
            type="submit"
            disabled={!email || !username || !password || !confirmPassword}
            className="retro-button w-100 small-btn"
          >
            Register
          </button>
        </Form>
        <p className="mt-3 text-center fs-6">
          Already have an account?{' '}
          <Link to="/login" className="link-danger">Login</Link>
        </p>
      </div>
    </Container>
  );
};

export default Register;
